package store.actions

import it.neckar.common.redux.ChangeType
import it.neckar.lizergy.model.project.ProjectConfiguration.PhotovoltaicsProjectId
import it.neckar.lizergy.model.stumps.FinishingUp
import store.PlannerClientState

/**
 * Updates a single project.
 * Does *not* navigate to the project
 */
data class UpdateFinishingUpAction(val projectId: PhotovoltaicsProjectId, val updatedFinishingUp: FinishingUp) : StateAction {
  override val type: ChangeType = ChangeType.HistoryReset

  override fun PlannerClientState.updateState(): PlannerClientState {
    println("Updating FinishingUp <${updatedFinishingUp.uuid}> for project <${projectId}>")

    val resolvedProject = this.resolvedProjects[projectId]
    val updatedProject = resolvedProject.copy(finishingUp = updatedFinishingUp)

    val updatedProjects = this.resolvedProjects.withUpdated(updatedProject)

    return this.copy(resolvedProjects = updatedProjects)
  }
}
